export const MAX_ATTEMPTS = 5;
export const INITIAL_BACKOFF = 1000;
export const MAX_BACKOFF = 5000;
export const BACKOFF_MULTIPLIER = 1.5;
export const JITTER = 20;
